import { ProjectRegisterModule } from './project/project-register.module';
import { NgModule } from "@angular/core";

@NgModule({
  imports: [
    ProjectRegisterModule,
  ]
})
export class ProjectsRepositoryRegisterModule {}
